export function dgramHas<T>(dgram: Partial<T>, criteria: Partial<T>): boolean {
  const key = Object.keys(criteria)[0];
  return key in dgram;
}

export class DgramSocket extends WebSocket {
  public dgram: any = {};
  public receiver: any = {};
  constructor(url: string, protocols?: string | string[]) {
    super(url, protocols);

    this.onmessage = (event) => {
      const data = JSON.parse(event.data.toString());
      if (dgramHas(data, { replace: {} })) {
        const dgram = data.replace;
        const firstKey = Object.keys(dgram)[0];
        // synthesize handler name based on dgram first key and it should be prefixed with 'on'
        const handlerName = `on${firstKey.charAt(0).toUpperCase()}${firstKey.slice(1)}`;
        // if the handler exists, call it with the dgram
        if (handlerName in this.receiver) {
          this.receiver[handlerName](dgram[firstKey]);
        }
      }
    }
  }

  public sendDgram(dgram: any) {
    this.send(JSON.stringify({ replace: dgram }));
  }
}

export async function sleep(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
